import {
    Box, Button, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination,
    TableRow, Accordion, AccordionSummary, AccordionDetails, Typography
} from "@material-ui/core";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
// styles

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import {
    Controller,
    useForm
} from "react-hook-form";
import { default as Apiservices } from '../../../common';
import DateRangePicker from "../../../components/DateRangePicker";
import useStyles from "../../../themes/makeStyles";
import FilterForm from "./filterForm";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import tableDataHeader from "../../../constants/TableDataConstants"


const useStyles1 = makeStyles((theme) => ({
    root: {
        flexShrink: 0,
        marginLeft: theme.spacing(0),
    },
}));

function TablePaginationActions(props) {

    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event) => {
        onChangePage(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onChangePage(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onChangePage(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };



    return (
        <div className={classes.root}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                        <KeyboardArrowLeft />
                    )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                        <KeyboardArrowRight />
                    )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </div>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles({
    table: {
        minWidth: "100%",
        whiteSpace: "nowrap",
        td: {

        }
    },
    toobarBgColor: {
        "& .MuiToolbar-regular": {
            background: "#fff",
        },
    },
    container: {
        maxHeight: "60vh",
        minHeight: "100px",
        overflowY: "hidden",
        "&:hover": {
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "4px",
            },

            /* Track */

            "&::-webkit-scrollbar-track": {
                background: "#fff",
            },

            /* Handle */

            "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#d4d8da",
                borderRadius: "20px",
            },

            /* Handle on hover */

            "&::-webkit-scrollbar-thumb:hover": {
                background: "",
            },
        },
    },
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export default function JobDetailsReport(props) {

    const GPWISTableHeaderDetails = tableDataHeader.GPWIS_JOB_DETAILS_REPORT_HEADER
    const GPWISTabelDataKeys = tableDataHeader.GPWIS_JOB_REPORT_KEYS
    const classesTwo = useStyles();
    const classes = useStyles2();
    const [page, setPage] = React.useState(0);
    const [array, setArray] = React.useState([
        { invoicedate: "No Data", count: "No Data" },
    ]);
    const [loading, setLoading] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [resetvalues, setResetvalues] = React.useState(true);
    const [saveFilterData, setSaveFilterData] = React.useState();
    const [sftorrEndDate, setSftorrEndDate] = React.useState();
    const [disableSftoButton, setDisableSftoButton] = React.useState(true);
    const [showFilterFlag, setShowFilterFlag] = useState(false);
    const [expandedPanel, setExpandedPanel] = useState({
        panel1: true,
        panel2: true
    });

    var tableData = [{
        destination: "No Data",
        ir_load_name: "No Data",
        ir_rake_id: "No Data",
        rr_actual_weight: "No Data",
        rr_amount: "No Data",
        rr_chargeable_weight: "No Data",
        rr_date: "No Data",
        rr_no: "No Data",
        rr_punitive: "No Data"
    }]

    const fetchData = async (data) => {
        //         let dataObj = [
        // "CustomerName",
        // "CustomerWorkOrderNo",
        // "IsJobConfirmed",
        // "LegNo",
        // "Origin",
        // "OriginCode",
        // "Destination",
        // "DestinationCode",
        // "JobAtDestination",
        // "Commodity",
        // "CargoOwnerName",
        // "RrNo",
        // "RrDate",
        // "RrAmount",
        // "RrAttachment",
        // "RakeArrivalAtServingStationDatetime",
        // "RakeArrivalAtStationDatetime",
        // "RakePlacementDatetime",
        // "RakeFullOrPartLoad",
        // "LocoDetachmentDatetime",
        // "RakeCleaningDatetime",
        // "RakeStatus",
        // "QuantityOfCargo",
        // "RrPunitive",
        // "IrLoadName",
        // "OriginLoadName",
        // "EotOfCustomerLoco",
        // "EotDatetime",
        // "OfferedToIr",
        // "DamageWagon",
        // "JobCompletedForThisLeg",
        // "ReasonForNonCompletionOfJob",
        // "RakeDepartureDatetimeFromStation",
        // "RakeDepartureDatetimeFromServingStation",
        // "GpsDeviceId",
        // "WagonNoAttachedToGps",
        // "TatOfLeg",
        // "TotalCycleTat",
        // "RecordStatus",
        // "Createddate",
        // "Createdby",
        // "Updateddate",
        // "Updatedby",
        // "CircuitName",
        // "Id",
        // "JobId",
        // "FreightToBePaidBy",
        // "JobStatus",
        // "CycleId",
        // "JobApprovalStatus",
        // "JobRemarks",
        // "MainStepId",
        // "SubStepId",
        // "ApprovedBy",
        // "ApproverRemarks",
        // "ApprovedDate",
        // "RakeName",
        // "RrRemarks",
        // "RebateAmount",
        // "SapIoId",
        // "SapSoId",
        // "SapSoInvoiceId",
        // "SapLineitemNo",
        // "ServMatNo",
        // "ServMatDesc",
        // "TargetQtyUom",
        // "TargetQty",
        // "UnitPrice",
        // "ShipToParty",
        // "CustomerRef",
        // "CustomerRefDate",
        // "SapCustomerId",
        // "CustGrp5",
        // "SapRakeNumber",
        // "PurchaseContractNo",
        // "PurchaseContractLineitemNo",
        // "SapShipToParty",
        // "TotalFee",
        // "ChargeableQuantity",
        // "RrAttachmentDmsFileid",
        // "RrChargeableQuantity",
        // "InvoiceCreatedDate",
        // "SoCreatedDate",
        // "VendorCode",
        // "CostCenter",
        // "RrActualWeight",
        // "SoGroup",
        // "SoNumber",
        // "InvoiceNumber",
        // "InvoiceGenerated",
        // "Ischecked",
        // "CommodityLoaded",
        // "PaymentTerms",
        // "JobCreatedUserEmailid",
        // "MapMyIndiaId",
        // "LoadingStartDatetime",
        // "LoadingEndDatetime",
        // "NoOfWagonsLoaded",
        // "ForwardingNoteAttachment",
        // "InvoiceParty",
        // "ConfirmInvoice",
        // "IsInvoiceSentToCustomer",
        // "DamageToWagon",
        // "JobCompleteForThisLeg",
        // "ReasonForNonCompletion",
        // "ForwardingNoteAttachmentDmsFileid",
        // "InvoiceBillDate",
        // "OtherChargeName",
        // "OtherChargeValue",
        // "Remarks",
        // "UnloadingStartDatetime",
        // "UnloadingCompletionDatetime",
        // "NoOfWagonsUnloaded",
        // "RevenueDetails",
        // "PurchaseDetails"
        //             ]
        //             const  camalize = (str)  => {
        //             return str.replace(/([a-z])([A-Z])/g, '$1 $2');
        //         }
        //         let arr = []
        //         dataObj.map(item =>{
        //             let cam = camalize(item)
        //             arr.push(cam)
        //         })

        //         console.log(arr, "camalized arr")
        let response;
        if (data) {
            response = await Apiservices.getGpwisJobDeatilsReport(data);
        } else {
            response = await Apiservices.getGpwisJobDeatilsReport();
        }
        if (response && response.Records.length > 0) {
            setArray(response.Records && response.Records.length > 0 ? response.Records : []);
        } else {
            setArray([]);
            console.log("Server not working")
        }
        console.log(response, "apiresp")
    }

    const methods = useForm({
        mode: "onChange",
        validateCriteriaMode: "all",
        // defaultValues: getHeaderInfoDefaultData(modeOfDispatch),
    });

    const handleAccordionChange = (panel, expandedPanel) => (
        event,
        isExpanded
    ) => {
        let expansionPanelList = {};
        expansionPanelList = expandedPanel;

        expansionPanelList[panel] = expansionPanelList[panel] ? false : true;
        setExpandedPanel({
            panel1:
                panel === "panel1"
                    ? expansionPanelList[panel]
                    : expansionPanelList["panel1"],
            panel2:
                panel === "panel2"
                    ? expansionPanelList[panel]
                    : expansionPanelList["panel2"],
        });
    };

    const {
        register,
        control,
        errors,
        handleSubmit,
        setValue,
        reset,
        getValues,
    } = methods;

    useEffect(() => {
        const response = fetchData();
    }, []);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        let params = {}
        params.limit = newPage - 1
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const getSplInstructions = (instructions) => {
        let value = '';
        let spitOfInstructions = instructions.split(" ");
        for (let i = 0; spitOfInstructions.length; i++) {
            if (spitOfInstructions[i] === 'Load' || spitOfInstructions[i] === 'LOAD' || spitOfInstructions[i] === 'load') {
                value = value + ' ' + spitOfInstructions[i];
                return value;
            } else {
                value = value + ' ' + spitOfInstructions[i];
            }
        }
        return value;
    }

    const getRakeIdFromName = (rakeId) => {
        let splitRakeId = rakeId.split("/");
        return splitRakeId[0];
    }


    const handleSearchCriteriaSubmit = async (submitteddata) => {
        let queryparams = {};
        let rr_start_end_dates = submitteddata.rr_start_end_date
            ? submitteddata.rr_start_end_date.split("To")
            : null;
        queryparams.rr_start_date = rr_start_end_dates
            ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
            : null;
        queryparams.rr_end_date = rr_start_end_dates
            ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
            : null;
        setLoading(true);
        let response = await Apiservices.getSftoJobDeatilsReport(queryparams);
        if (response && response.Records.length > 0) {
            setArray(response.Records && response.Records.length > 0 ? response.Records[0] : []);
            setDisableSftoButton(false);
        } else {
            setArray([]);
            console.log("Server not working")
        }
        setLoading(false);
    };


    const getFilterData = (values) => {
        // setSaveSearchTerm(null)
        setSaveFilterData(values)
        fetchData(values)
        // setCheckedList([]);
    }

    const handleClear = () => {
        // setSaveSearchTerm(null)
        setSaveFilterData(null)
        fetchData();
    }

    const resetForm = async () => {
        setResetvalues(!resetvalues);
        setDisableSftoButton(true);
        let obj = {
            rr_start_date: '2009-01-01',
            rr_end_date: '2070-01-01'
        }
        setLoading(true);
        let response = await Apiservices.getSftoJobDeatilsReport(obj);
        setArray(response.Records && response.Records.length > 0 ? response.Records[0] : []);
        setLoading(false);
    };

    const checkIfvalueIsDate = (value) => {
        if (typeof (value) === 'string') {
            console.log(value && value.includes("-"), "includde-1")
            return value.includes("T") && value.includes("-")
        } else {
            return false
        }
    }

    return (
        <>
            <div>
                <Box py={3}>
                    <Grid container spacing={2} justify="space-between" alignItems="center">
                        <Grid item>
                            <h2 className={classesTwo.mainHeading}>{"GPWIS - Job Details Report"}</h2>
                        </Grid>
                    </Grid>
                </Box>

                <Box py={1}>
                    <form
                        // onSubmit={handleSubmit(handleSearchCriteriaSubmit)}
                        id="list-job"
                        key={resetvalues}
                    >
                        {showFilterFlag ? (
                            <div />
                        ) : (
                                <Box py={1}>
                                    <Paper elevation={0}>
                                        <Accordion
                                            expanded={expandedPanel["panel1"] === true}
                                            onChange={handleAccordionChange("panel1", expandedPanel)}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                            >
                                                <Typography className={classes.secondHeading}>
                                                    Filter By
                                    </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <Box width={'100%'}>
                                                    <FilterForm getFilterData={getFilterData} handleClear={handleClear} />
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion>
                                    </Paper>
                                </Box>
                            )}
                    </form>
                </Box>

                <div>
                    {array.length > 0 ? (
                        <Box py={1}>
                            <TableContainer component={Paper} className={clsx('freezeTable', classes.container)}>
                                <Table
                                    // className={clsx('freezeTable')}
                                    aria-label="simple table"
                                    stickyHeader
                                >
                                    {loading ? (
                                        <></>
                                    ) : (
                                            <>
                                                <TableHead>
                                                    <TableRow>
                                                        {GPWISTableHeaderDetails && GPWISTableHeaderDetails.map((item, index) => {
                                                            return (
                                                                <StyledTableCell key={index} align={item === "Job Id" ? "Left" : "center"} style={{ minWidth: item === "Job Id" ? 210 : '', maxWidth: item === "Job Id" ? 220 : '' }} >
                                                                    <b>{item} </b>
                                                                </StyledTableCell>
                                                            )
                                                        })}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? array?.slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        : array
                                                    ).map((row, index) => (
                                                        <TableRow key={index}>
                                                            {GPWISTabelDataKeys && GPWISTabelDataKeys.map((item, colIndex) => {
                                                                return (
                                                                    <TableCell key={colIndex} align={item === "job_id" ? "Left" : "center"} style={{ minWidth: item === "job_id" ? 200 : '', maxWidth: item === "job_id" ? 200 : '' }} >
                                                                        {row[item] ? (checkIfvalueIsDate(row[item]) ? <b>{moment(row[item]).format('DD-MM-YYYY')}</b> : <b>{row[item]}</b>) : (<b>-</b>)}
                                                                    </TableCell>
                                                                )
                                                            })}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow></TableRow>
                                                </TableFooter>
                                            </>
                                        )}
                                </Table>
                            </TableContainer>
                            <TableContainer>
                                <TablePagination
                                    className={classes.toobarBgColor}
                                    rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                                    component="div"
                                    count={array && array.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: { "aria-label": "rows per page" },
                                        native: true,
                                    }}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableContainer>
                        </Box>
                    ) : <Box py={1}>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <Grid item xs={12} sm>
                                    <Box my={1}>
                                        <h3 classname={classes.secondHeading}>No Records Found</h3>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>}
                </div >
            </div>
        </>
    );
}